import { render, staticRenderFns } from "./settings-redchirp-billing.vue?vue&type=template&id=2c6e6a5a&"
import script from "./settings-redchirp-billing.vue?vue&type=script&lang=js&"
export * from "./settings-redchirp-billing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports